import Vue from 'vue'
import notificationTransformer from './../transformers/'

export default () => {
  return Vue.$http.get('commons/notifications/')
    .then(({ data }) => {
      return notificationTransformer.fetchCollection(data)
    }).catch((error) => {
      throw error
    })
}
